
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Table } from "antd";
import "./antd.css";
import { onShowSizeChange } from "../components/pagination";

const Datatable = ({ columns, response, fetchData , SelectedRows, NoPagination, isLoading, onRowClick }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    // Fetch data when the component mounts
    fetchData({page:pagination.current, pageSize:pagination.pageSize});
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    if(response?.resetPageSize){
      console.log("resetPageSize");
      setPagination({...pagination ,pageSize:10,total:response?.totalDataCount});
    }else{
      setPagination({...pagination ,total:response?.totalDataCount});
    }
    // console.log(pagination);
  }, [response?.data]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    SelectedRows(newSelectedRowKeys)
  };

  const handleTableChange = (pagination) => {
    // console.log(pagination);
    setPagination(pagination);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  return (
    <Table
      className="table datanew dataTable no-footer"
      loading={isLoading}
      rowSelection={SelectedRows? rowSelection : null}
      columns={columns}
      onRow={(record, rowIndex) => {
        return {
          onClick: (event) => {
            if(onRowClick){
              onRowClick(record);
            }
          },
        };
      }
      }
      dataSource={response?.data}
      pagination={ NoPagination ? false : {
        ...pagination,
        showTotal: (total, range) =>
          ` ${range[0]} to ${range[1]} of ${total} items`,
        showSizeChanger: true,
        pageSizeOptions:[10,50,100,500,1000,1000000000],
        onShowSizeChange: onShowSizeChange,
      }}
      rowKey={(record) => record.id}
      onChange={handleTableChange}
    />
  );
};

export default Datatable;
